import styled from 'styled-components';
import { Row as ANTDRow } from 'antd';

export const Row = styled(ANTDRow)`
    display: block;
`;